// extracted by mini-css-extract-plugin
module.exports = {"displayArea":"ViewBatches_displayArea__2ghml","addBatch":"ViewBatches_addBatch__3KuyQ","deleteBatch":"ViewBatches_deleteBatch__PzEnU"};